// extracted by mini-css-extract-plugin
export default {"Feedback":"Feedback_Feedback__pF1Z2","stars":"Feedback_stars__p58XU","star":"Feedback_star__GjevN","text":"Feedback_text__LuKWc","signature":"Feedback_signature__z44wG"};